/**
 * Renders a cluster bubble (a circle with a count) as a `data:image/svg+xml;…`
 * URL — fed directly to `google.maps.Marker.setIcon`. The radius scales by
 * the count band so a 5-pin cluster reads tighter than a 200-pin cluster.
 *
 * Color sourcing follows the active palette via the caller — `accentHex` is
 * the bubble fill and `accentInkHex` is the count text color. The white
 * stroke around the bubble gives it a clean ring against arbitrary map
 * imagery (tiles, satellite, dark mode etc.).
 */

/**
 * Compose a circular cluster-count bubble SVG and return it as a data-URL.
 * Radius bands:
 *   - `< 10`  → 18 px outer radius
 *   - `< 100` → 22 px outer radius
 *   - `>= 100` → 26 px outer radius
 */
export function composeClusterBubbleSvg(
  count: number,
  accentHex: string,
  accentInkHex: string,
): string {
  const r = count < 10 ? 18 : count < 100 ? 22 : 26;
  const size = r * 2;
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" ` +
    `viewBox="0 0 ${size} ${size}">` +
    `<circle cx="${r}" cy="${r}" r="${r - 2}" fill="${accentHex}" ` +
    `stroke="white" stroke-width="2"/>` +
    `<text x="${r}" y="${r + 5}" text-anchor="middle" font-family="system-ui" ` +
    `font-size="14" font-weight="600" fill="${accentInkHex}">${count}</text>` +
    `</svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}
